import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpointInsert = '/api/updateNovedad';

const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const updateNovedad = async (id, data, tipo_novedad) => {
    try {
      const response = await axios.put(`${baseUrl}${orgEndpointInsert}`, {id:id, detalle: data, tipo_novedad:tipo_novedad }, {
        headers: {
            'Content-Type': 'application/json',  // Encabezado JSON para enviar datos correctamente
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar la novedad:', error);
      throw error;
    }
  };
  export default updateNovedad;